export type ComponentSearchDialogState = {
  componentList: Component[];
  isShow: boolean;
  selectedCpntId?: string[];
  isSaved: boolean;
};
export type Component = {
  isSelect?: boolean;
  dipByRgn: string;
  rootCpntId: string;
  cpntId: string;
  cpntName: string;
};
export type PageNewState =
  | ComponentSearchDialogState
  | ((prevState: ComponentSearchDialogState) => ComponentSearchDialogState);
